module.exports = __webpack_public_path__ + "static/media/plan_san_bernando.ac8f93e3.png";